import { defineStore } from 'pinia'

export default defineStore({
  id: 'report',
  persist: true,
  state: () => {
    return {
      templateStatistic: null as null | { [key: string]: string }
    }
  },
  actions: {
    clear: function () {
      this.templateStatistic = null
    },
    setTemplateStatistic: function (payload: any) {
      this.templateStatistic = payload || null
    }
  },
  getters: {
    getTemplateStatistic: (state: any) => state.templateStatistic
  }
})
